import { format } from 'date-fns';
import { fetchWithProductBearer } from '@braincube/jwt-browser';
import { getConfig } from '../configuration';
import formatInternalLog from '../utils/format';
const check = () => {
  var _window, _window$BC_API_ENDPOI;
  const productName = getConfig('productName');
  let configIsOk = true;
  if (!productName) {
    console.error(formatInternalLog('Cannot log to graylog as the productName is not defined'));
    configIsOk = false;
  }
  if (!((_window = window) !== null && _window !== void 0 && (_window$BC_API_ENDPOI = _window.BC_API_ENDPOINTS_CONF) !== null && _window$BC_API_ENDPOI !== void 0 && _window$BC_API_ENDPOI.api)) {
    console.error(formatInternalLog('Cannot log to graylog as the window.BC_API_ENDPOINTS_CONF.api is not defined'));
    configIsOk = false;
  }
  return configIsOk;
};
const pushToGrayLog = (message, data, level = 'INFO') => {
  const productName = getConfig('productName');
  const appName = getConfig('appName');
  const version = getConfig('version');
  const productId = getConfig('productId');
  const packageName = getConfig('packageName');
  const additionnalData = {
    ...data
  };
  if (productId) {
    additionnalData.productId = productId;
  }
  const logWs = `https://${window.BC_API_ENDPOINTS_CONF.api}/braincube/${productName}/log`;
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  if (packageName) {
    headers.append('X-app-key', btoa(packageName));
  }
  fetchWithProductBearer(`${logWs}`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      host: productName,
      app: appName,
      version,
      messages: [{
        date: format(new Date(), 'yyyyMMdd_HHmmssSSS xxx'),
        level,
        msg: message,
        type: '',
        data: additionnalData
      }]
    })
  }).catch(error => {
    console.error(formatInternalLog('Fetching log failed'), error);
  });
};
const logger = {
  key: 'graylog',
  check,
  init: () => {},
  handle: (level, message, data) => {
    switch (level) {
      case 'info':
        pushToGrayLog(message, data);
        break;
      case 'warn':
        pushToGrayLog(message, data, 'WARNING');
        break;
      case 'error':
        pushToGrayLog(message, data, 'SEVERE');
        break;
      default:
        console.error(formatInternalLog(`Unknown or logging not available for the level ${level}`));
    }
  }
};
export default logger;